import { Row } from 'antd'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import JobHashtags from 'src/common/components/hashtag/JobHashtags'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { isJobManagerRole } from 'src/helpers/constants'
import { useStore } from 'src/hooks'

interface JobDetailTagListProps {
   // Bam vao hashtag -> tim cac job co hashtag nay
   onSearchHashtag?: (name: string) => void
}

const JobDetailTagList: React.FC<JobDetailTagListProps> = observer(({ onSearchHashtag }) => {
   const { t } = useTranslation()
   const JobDetailStore = useStore('JobDetailStore')
   const AuthStore = useStore('AuthStore')
   const { jobDetail } = JobDetailStore
   // Moi role deu xem duoc, chi admin / supporter gan / go
   const canEdit = isJobManagerRole(AuthStore.data_role)

   // Khong sua duoc ma job chua co hashtag thi an ca muc
   if (!canEdit && !String(jobDetail?.tag || '').trim()) return null

   return (
      <>
         <Row className="gx-flex-row gx-align-items-center gx-justify-content-between gx-mb-2 gx-mx-1" wrap={false}>
            <h4 style={{ fontSize: 14, fontWeight: 600, lineHeight: '22px', color: '#272944' }}>
               {t(GLOBAL_CLIENT.hashtagTitle)}
            </h4>
         </Row>
         <div className="gx-mb-2 gx-mx-1">
            <JobHashtags
               jobId={jobDetail?.id}
               tag={jobDetail?.tag}
               // Gan / go hashtag duoc o moi trang thai, luu ngay khong can bam Sua
               canEdit={canEdit}
               onSearchHashtag={onSearchHashtag}
            />
         </div>
      </>
   )
})

export default JobDetailTagList
